import { render, staticRenderFns } from "./UCIrvineELN4FSSafety1.vue?vue&type=template&id=13bbae7e&scoped=true&"
import script from "./UCIrvineELN4FSSafety1.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineELN4FSSafety1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbae7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VFileInput,VForm,VImg,VRow,VTextarea})
